export const ExamTypesEnum = Object.freeze({
  TOP: 'top',
  MIJN: 'mijn',
});